import { useRef, useEffect } from "react";
import { TextB, TextItalic, ListBullets, ListNumbers } from "@phosphor-icons/react";

export const RichTextEditor = ({ value, onChange, placeholder, testId }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && value && !ref.current.innerHTML) {
      ref.current.innerHTML = value;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exec = (cmd) => {
    document.execCommand(cmd);
    ref.current?.focus();
    onChange(ref.current?.innerHTML || "");
  };

  return (
    <div className="border border-border" style={{ borderRadius: "2px" }}>
      <div className="flex items-center gap-1 px-2 py-1.5 border-b border-border bg-muted/50">
        <button type="button" data-testid={`${testId}-bold-btn`} onClick={() => exec("bold")} className="p-1.5 hover:bg-muted" style={{ borderRadius: "2px" }}><TextB size={14} /></button>
        <button type="button" data-testid={`${testId}-italic-btn`} onClick={() => exec("italic")} className="p-1.5 hover:bg-muted" style={{ borderRadius: "2px" }}><TextItalic size={14} /></button>
        <button type="button" data-testid={`${testId}-ul-btn`} onClick={() => exec("insertUnorderedList")} className="p-1.5 hover:bg-muted" style={{ borderRadius: "2px" }}><ListBullets size={14} /></button>
        <button type="button" data-testid={`${testId}-ol-btn`} onClick={() => exec("insertOrderedList")} className="p-1.5 hover:bg-muted" style={{ borderRadius: "2px" }}><ListNumbers size={14} /></button>
      </div>
      <div
        ref={ref}
        data-testid={testId}
        contentEditable
        suppressContentEditableWarning
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        className="min-h-[90px] max-h-60 overflow-y-auto p-3 text-sm focus:outline-none empty:before:content-[attr(data-placeholder)] empty:before:text-muted-foreground"
        data-placeholder={placeholder}
      />
    </div>
  );
};
